module.exports = __webpack_public_path__ + "img/paynow.7da2d013.svg";